import * as R from 'remeda';
import { organizationBranding } from '../../../features/client-config/organization/branding';
import { statisticsFeatureSelector } from '../../../features/pricing/selectors';
import createSelector from '../../../lib/createDeepEqualSelector';
import { Organization } from '../../../types/organization';
import { State } from '../../../types/state';

/**
 * @deprecated
 */
export const organizationSelector = (state: State): Partial<Organization> =>
  state.organization;

export const safeOrganizationSelector = (
  state: State
): Organization | undefined =>
  state.organization.id ? (state.organization as Organization) : undefined;

const usageReportsEnabledSelector = createSelector(
  organizationSelector,
  organization => organization?.uiSettings?.features?.usage_reports
);

export const isTrialSelector = (state: State): boolean | undefined =>
  organizationSelector(state).isTrial;

export const canUseUsageReportsSelector = createSelector(
  isTrialSelector,
  usageReportsEnabledSelector,
  statisticsFeatureSelector,
  (isTrial, usageReportsEnabled, organizationGroupUsageReportsEnabled) =>
    // we still need control to disable statistics for selected organizations within org group,
    // fallback to global pricing flag otherwise...
    usageReportsEnabled ?? organizationGroupUsageReportsEnabled ?? isTrial
);

export const hasBrandingSelector = createSelector(
  organizationSelector,
  organization => !R.isEmpty(organization.uiSettings?.branding ?? {})
);

// This option is for OEM customers, who want to hide the Aurora branding across app
export const poweredByAuroraSelector = createSelector(
  safeOrganizationSelector,
  organization =>
    organization
      ? organizationBranding.displayAuroraBranding(organization.uiSettings)
      : true
);

export const hideArticleLinksSelector = createSelector(
  safeOrganizationSelector,
  organization =>
    organization
      ? !organizationBranding.showExternalResources(organization.uiSettings)
      : false
);

export const statisticsUserReportsDisabled = createSelector(
  organizationSelector,
  organization =>
    organization?.uiSettings?.statistics?.disable_user_reports ?? false
);

export const isSSOEnable = createSelector(
  safeOrganizationSelector,
  organization =>
    !!organization?.internalInfo?.ssoActive ||
    !!organization?.oidcProvider ||
    false
);

export const supportMenuItemsSelector = createSelector(
  safeOrganizationSelector,
  organization =>
    organization ? organizationBranding.supportMenuItems(organization) : null
);

export const overduePaymentDateSelector = createSelector(
  safeOrganizationSelector,
  organization => organization?.internalInfo?.overduePaymentDate
);

export const customerTypeSelector = createSelector(
  organizationSelector,
  organization => organization?.internalInfo?.customerType
);
